import {
    RACING_INIT,
    RACING_UPDATE_SCHEDULE,
    RACING_UPDATE_SCHEDULE_FROM_CACHE,
    RACING_INVALIDATE_SCHEDULE_CACHE,
    RACING_WS_EVENT_UPDATE,
    RACING_WS_EVENT_UNSUBSCRIBE,
} from './types';

export const racingInit = data => ({
    type: RACING_INIT,
    data,
});

export const updateSchedule = data => ({
    type: RACING_UPDATE_SCHEDULE,
    data,
});

export const updateScheduleFromCache = (cachedEvents, raceType) => ({
    type: RACING_UPDATE_SCHEDULE_FROM_CACHE,
    cachedEvents,
    raceType,
});

export const invalidateCache = raceType => ({
    type: RACING_INVALIDATE_SCHEDULE_CACHE,
    raceType,
});

export const subscribeWsEventUpdates = events => {
    const wsEventsList = [];
    Object.keys(events).forEach(event_id => {
        wsEventsList.push({ event_id });
    });

    return {
        type: RACING_WS_EVENT_UPDATE,
        wsEventsList,
    };
};

export const unsubscribeWsEventUpdates = raceType => {
    return {
        type: RACING_WS_EVENT_UNSUBSCRIBE,
        raceType,
    };
};
